import { useLocation, useNavigate } from 'react-router-dom';
import FaceIdentityBrandLogo from '../../face-identity/components/FaceIdentityBrandLogo';
import FaceIdentityFlowNav from '../../face-identity/components/FaceIdentityFlowNav';
import { useFaceIdentityOrgLogo } from '../../face-identity/hooks/useFaceIdentityOrgLogo';
import { useBeautyProduct } from '../../../beauty-shared/context/BeautyProductContext';
import './MakeupHairAppHeader.css';

export default function MakeupHairAppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hubPath, appPath, appBase, title } = useBeautyProduct();
  const { orgLogoUrl, showLogo, onLogoError } = useFaceIdentityOrgLogo();
  const path = String(location.pathname || '');
  const onStudio = path.includes('/studio');
  const onPreview = path.includes('/capture/preview');
  const onCapture = path.includes('/capture') && !onPreview;
  const showProductTitle = String(appBase || '').includes('/looks');

  const handleBack = () => {
    if (onStudio) {
      navigate(appPath('/capture'));
      return;
    }
    if (onPreview) {
      navigate(appPath('/capture'));
      return;
    }
    if (onCapture) {
      navigate(hubPath);
      return;
    }
    navigate(hubPath);
  };

  return (
    <header className="makeup-hair-app-header makeup-hair-app-header--flow-nav">
      <div className="makeup-hair-app-header__brand">
        <FaceIdentityBrandLogo
          showLogo={showLogo}
          orgLogoUrl={orgLogoUrl}
          onLogoError={onLogoError}
          className="makeup-hair-app-header__logo-wrap"
          imgClassName="makeup-hair-app-header__logo"
          fallbackClassName="makeup-hair-app-header__logo-fallback"
          alt="Franchise"
        />
        {showProductTitle && title ? (
          <span className="makeup-hair-app-header__product-title">{title}</span>
        ) : null}
      </div>
      <FaceIdentityFlowNav
        homePath={hubPath}
        onHome={() => navigate(hubPath)}
        onBack={handleBack}
        onRefresh={() => {
          if (typeof window !== 'undefined') window.location.reload();
        }}
        showBack
        showHome
        showRefresh
        showLogout
      />
    </header>
  );
}
